export default defineNuxtRouteMiddleware(async (to, from) => {
  try {
    if (to.meta.pageTransition && typeof to.meta.pageTransition !== 'boolean')
      to.meta.pageTransition.name = +to.params.id > +from.params.id ? 'slide-left' : 'slide-right'
  }
  catch (e) {
    console.warn('[middleware] ', e)
  }
})
